import { __decorate, __metadata } from "tslib";
import { Expose, Model, ModelId } from '@core/shared/model';
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
let MembershipRegistrationResponse = /*#__PURE__*/(() => {
  let MembershipRegistrationResponse = class MembershipRegistrationResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Boolean)], MembershipRegistrationResponse.prototype, "success", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], MembershipRegistrationResponse.prototype, "paymentPending", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MembershipRegistrationResponse.prototype, "membershipUuid", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MembershipRegistrationResponse.prototype, "sessionId", void 0);
  MembershipRegistrationResponse = __decorate([ModelId("MembershipRegistrationResponse") // auto-generated by generate-model-ids
  ], MembershipRegistrationResponse);
  return MembershipRegistrationResponse;
})();
export { MembershipRegistrationResponse };
let MembershipRegistrationRequest = /*#__PURE__*/(() => {
  let MembershipRegistrationRequest = class MembershipRegistrationRequest extends Model {
    static {
      this.Response = MembershipRegistrationResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], MembershipRegistrationRequest.prototype, "membershipType", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MembershipRegistrationRequest.prototype, "membershipTypeCategorization", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MembershipRegistrationRequest.prototype, "referrerCode", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MembershipRegistrationRequest.prototype, "formData", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MembershipRegistrationRequest.prototype, "account", void 0);
  MembershipRegistrationRequest = __decorate([AppRequest('membership', 'registration', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId', 'sessionId']
  }), ModelId("MembershipRegistrationRequest") // auto-generated by generate-model-ids
  ], MembershipRegistrationRequest);
  return MembershipRegistrationRequest;
})();
export { MembershipRegistrationRequest };
let MembershipPaymentAssignOrderIdRequest = /*#__PURE__*/(() => {
  let MembershipPaymentAssignOrderIdRequest = class MembershipPaymentAssignOrderIdRequest extends Model {};
  __decorate([Expose(), __metadata("design:type", String)], MembershipPaymentAssignOrderIdRequest.prototype, "membershipUuid", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MembershipPaymentAssignOrderIdRequest.prototype, "ppOrderId", void 0);
  MembershipPaymentAssignOrderIdRequest = __decorate([AppRequest('membership', 'payment/assign-order-id', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("MembershipPaymentAssignOrderIdRequest") // auto-generated by generate-model-ids
  ], MembershipPaymentAssignOrderIdRequest);
  return MembershipPaymentAssignOrderIdRequest;
})();
export { MembershipPaymentAssignOrderIdRequest };
let MembershipApprovePaypalPaymentRequest = /*#__PURE__*/(() => {
  let MembershipApprovePaypalPaymentRequest = class MembershipApprovePaypalPaymentRequest extends Model {
    static {
      this.Response = MembershipRegistrationResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], MembershipApprovePaypalPaymentRequest.prototype, "membershipUuid", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], MembershipApprovePaypalPaymentRequest.prototype, "transactionDetails", void 0);
  MembershipApprovePaypalPaymentRequest = __decorate([AppRequest('membership', 'payment/approve', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("MembershipApprovePaypalPaymentRequest") // auto-generated by generate-model-ids
  ], MembershipApprovePaypalPaymentRequest);
  return MembershipApprovePaypalPaymentRequest;
})();
export { MembershipApprovePaypalPaymentRequest };